import { ExpandMore } from '@mui/icons-material';
import { useTheme } from '@mui/material';
import { GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton } from '@mui/x-data-grid';
import { useGridApiContext } from '@mui/x-data-grid-pro';
import { ChangeEvent, useState } from 'react';
import { SearchBar } from 'ui-component/SearchBar';

export const CustomGridToolbar = () => {
    const { palette } = useTheme();
    const apiRef = useGridApiContext();
    const [searchText, setSearchText] = useState('');

    const handleChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
        const newVal = e.target.value;

        apiRef.current.setQuickFilterValues([newVal]);
        setSearchText(newVal);
    };

    return (
        <GridToolbarContainer sx={{ gap: 0.5, mb: 1 }}>
            <SearchBar
                value={searchText}
                sx={{
                    '& .MuiInputBase-root': { background: 'white' },
                    '& .input-hot-keys > div': { background: palette.primary[300] }
                }}
                size="small"
                onChange={handleChangeSearch}
            />
            <GridToolbarColumnsButton
                sx={{
                    color: palette.primary[400],
                    backgroundColor: 'white',
                    borderRadius: '30px',
                    padding: '8px 16px'
                }}
                endIcon={<ExpandMore />}
            />
            <GridToolbarFilterButton
                sx={{
                    color: palette.primary[400],
                    backgroundColor: 'white',
                    borderRadius: '30px',
                    padding: '8px 16px'
                }}
                componentsProps={{ button: { endIcon: <ExpandMore /> } }}
            />
        </GridToolbarContainer>
    );
};
